import styled from 'styled-components';

export const StyledQuestionEditorContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 16px;
`;

export const StyledQuestionEditorColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex-grow: 1;
`;

export const StyledQuestionEditorRow = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
`;

export const StyledAnswerRow = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
`;

export const StyledQuestionFieldContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
`;

export const StyledTwoColumnGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 32px;
`;

export const StyledButtonsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 16px;
`;

export const StyledHeaderRowContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
`;
